<div class="card location-card" [class.active]="active" tabindex="0" role="button" [attr.aria-pressed]="active">
  <div class="card-body-wrapper">
    <!-- Left: Image Section -->
    <div class="image-section">
      <div class="image-container">
        <!-- Badge overlay on image -->
        <span *ngIf="badge" class="location-badge" [ngClass]="badge.class">{{ badge.label }}</span>
        <!-- Favorite button -->
        <button 
          class="favorite-btn" 
          [class.favorited]="favorited"
          type="button" 
          [attr.aria-label]="favorited ? 'Remove from favorites' : 'Add to favorites'"
          (click)="toggleFavorite($event)">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
          </svg>
        </button>
        <!-- Location image -->
        <div class="location-image">
          <div class="image-slider" [class.slide-left]="slideDirection === 'left'" [class.slide-right]="slideDirection === 'right'">
            <img 
              *ngIf="hasImages && currentImage" 
              [src]="currentImage" 
              [alt]="location.Name"
              class="location-img"
              (error)="onImageError()"
              [attr.loading]="currentImageIndex > 0 ? 'lazy' : 'eager'"
              [attr.data-index]="currentImageIndex"
            />
          </div>
          <!-- Fallback placeholder if no images or image fails to load -->
          <svg 
            *ngIf="!hasImages || !currentImage" 
            viewBox="0 0 400 300" 
            class="w-100 h-100" 
            preserveAspectRatio="xMidYMid slice" 
            aria-hidden="true">
            <rect width="400" height="300" fill="#e9ecef"></rect>
            <rect x="50" y="50" width="300" height="200" fill="#d0d0d0" rx="4"></rect>
            <text x="50%" y="50%" text-anchor="middle" fill="#999" font-size="18" dy=".3em">{{ location.Name }}</text>
          </svg>
          
          <!-- Navigation chevrons -->
          <button 
            *ngIf="canNavigate && hasImages" 
            class="nav-chevron nav-chevron-left"
            (click)="previousImage($event)"
            aria-label="Previous image"
            type="button">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </button>
          <button 
            *ngIf="canNavigate && hasImages" 
            class="nav-chevron nav-chevron-right"
            (click)="nextImage($event)"
            aria-label="Next image"
            type="button">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
        </div>
        <!-- Image carousel dots -->
        <div class="image-dots" *ngIf="hasImages && images.length > 1">
          <span 
            *ngFor="let img of images; let i = index"
            class="dot" 
            [class.active]="isActiveDot(i)"
            (click)="selectImage(i); $event.stopPropagation()"
            [attr.aria-label]="'View image ' + (i + 1) + ' of ' + images.length">
          </span>
        </div>
      </div>
    </div>

    <!-- Right: Content Section -->
    <div class="content-section">
      <div class="location-header">
        <div class="location-city-state">
          {{ location.City }}, {{ getStateAbbreviation(location.State) }}<span *ngIf="getDistanceDisplay()"> ({{ getDistanceDisplay() }})</span>
        </div>
        <h3 class="location-name">{{ location.Name }}</h3>
      </div>
      
      <!-- Separator line -->
      <div class="separator"></div>
      
      <!-- Amenities as dot-separated list -->
      <div class="amenities-list" *ngIf="false">
        <!-- Amenities can be added from Location data if available -->
      </div>
      
      <!-- Learn more link -->
      <div class="learn-more">
        <a href="#" class="learn-more-link">Learn more</a>
      </div>
      
      <!-- Rating and CTA Button Row -->
      <div class="rating-button-row">
        <!-- Rating -->
        <div class="rating" *ngIf="location.AverageRating">
          <span class="rating-star">★</span>
          <span class="rating-value">{{ location.AverageRating }}</span>
          <span class="rating-count">({{ location.ReviewCount || 0 }} reviews)</span>
        </div>
        
        <!-- CTA Buttons -->
        <div class="cta-buttons">
          <a class="btn-select" (click)="selectLocation($event)" [attr.href]="locationSelectUrl">
            SELECT
          </a>
          <button class="btn-directions" (click)="getDirections($event)" type="button">
            DIRECTIONS
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
